export default __webpack_public_path__ + "static/1-35f535f84450a1899e64c7371c64d284.jpg";